import {produce} from 'immer';
import {useAtom} from 'jotai';
import {useState} from 'react';
import {mapActionModeAtom} from '@/map/atom';
import {MapActionTypes} from '@/map/enums';
import {RulerItem} from '@/map/modules/Layer';
import {MeasureDistance, RulerOverlay} from '@/map/modules/Layer/Ruler';
import {palette} from '@/styles';

interface IProps {
  map: naver.maps.Map;
}

const borderColor = palette.teal200;
const mode = MapActionTypes.ruler;

export const RulerLayer = ({map}: IProps) => {
  const [action, setActionMode] = useAtom(mapActionModeAtom);
  const [items, setItems] = useState<
    Array<
      {
        id: number;
      } & RulerItem
    >
  >([]);

  const removeLayer = (layerId: number) => {
    if (layerId > 0) {
      setItems(
        produce((draft) => {
          const index = draft.findIndex((i) => i.id === layerId);
          if (index >= 0) {
            draft.splice(index, 1);
          }
        })
      );
    }
  };

  const onFinish = () =>
    setActionMode((prev) => (prev?.mode === mode ? null : prev));

  const onMeasureComplete = (distance: RulerItem) => {
    if (distance.mileStons?.length) {
      setItems(
        produce((prev) => {
          prev.push({
            id: new Date().getTime(),
            ...distance,
          });
        })
      );
    }
    onFinish();
  };

  if (!map) {
    return null;
  }

  const active = action?.mode === mode;

  return (
    <>
      {active && (
        <MeasureDistance
          map={map}
          borderColor={borderColor}
          startPoint={action.options?.point}
          onComplete={onMeasureComplete}
          onCancel={onFinish}
        />
      )}
      {items?.map((i) => (
        <RulerOverlay item={i} key={i.id} map={map} removeLayer={removeLayer} />
      ))}
    </>
  );
};
